import * as THREE from 'three';

import Particles from './particles/Particles';

export default class WebGLView {
	constructor(app) {
		this.app = app;

		this.samples = ['img/default.png'];
    this.container = document.getElementById('particles');

    this.particles = null;

		this.initThree();
		this.initParticles();
		// this.initControls();

    this.goto(0);
	}

	initThree() {
    const { clientWidth, clientHeight } = this.container;

		// scene
		this.scene = new THREE.Scene();
		// camera
		this.camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 1, 10000);
		this.camera.position.z = 300;
		// renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    // clock
		// this.clock = new THREE.Clock(true);
	}

	initParticles() {
		this.particles = new Particles(this);
		this.scene.add(this.particles.container);
	}

	update() {
		// const delta = this.clock.getDelta();
		// if (this.particles && this.particles.isAnimating) this.particles.update(delta);
	}

	draw() {
    this.renderer.render(this.scene, this.camera);
	}

	goto(index) {
    const isDefault = !this.samples && this.samples.includes(this.app.texture);
    this.particles.init(this.app.texture || this.samples[index], isDefault);
    // if (this.app.gui) this.app.gui.updateAll();
	}

	resize() {
		if (!this.renderer) return;

    const { clientWidth, clientHeight } = this.container;

		// this.camera.aspect = window.innerWidth / window.innerHeight;
		this.camera.aspect = clientWidth / clientHeight;
		this.camera.updateProjectionMatrix();

		this.fovHeight = 2 * Math.tan((this.camera.fov * Math.PI) / 180 / 2) * this.camera.position.z;

		this.renderer.setSize(clientWidth, clientHeight);

		if (this.particles) this.particles.resize();
	}
}
